<script>
import leave from "@/mixins/leave";
import imageService from "@/services/image";

export default {
  name: "ModalMedicalPractice",
  mixins: [leave],

  props: {
    showDialogModal: {
      type: Boolean,
    },
    currentPractice: {
      type: Object,
    },
  },

  data() {
    return {
      isPosting: false,
      categories: [],
      // El código no se pide en el formulario: en el alta lo autogenera el
      // backend (MANUAL-NNNN) y en la edición se conserva el que ya tenía.
      practice: {
        description: "",
        category: "",
        isActive: true,
      },
      isUpdate: !!this.currentPractice?._id,
      isShowed: this.showDialogModal,
    };
  },

  created() {
    this.loadCategories();

    if (this.isUpdate) {
      this.practice = { ...this.currentPractice };
    }
  },

  mounted() {
    document.addEventListener("keyup", this.escape);
  },

  beforeDestroy() {
    document.removeEventListener("keyup", this.escape);
  },

  methods: {
    async loadCategories() {
      try {
        const categories = await imageService.getCategories();
        this.categories = [
          ...new Set(categories.map((c) => String(c).trim())),
        ].sort((a, b) => a.localeCompare(b));
      } catch (error) {
        this.categories = [];
      }
    },

    escape(event) {
      if (event.keyCode == 27) this.close();
    },

    submit() {
      if (this.isUpdate) {
        this.updatePractice();
      } else {
        this.createPractice();
      }
    },

    createPractice() {
      this.isPosting = true;

      imageService
        .createImage(this.practice)
        .then((practice) => {
          this.$bus.$emit("medical-practice-created", practice);
          this.close();
        })
        .catch(() => {
          this.isPosting = false;
        });
    },

    updatePractice() {
      this.isPosting = true;

      imageService
        .updateImage(this.practice._id, this.practice)
        .then((practice) => {
          this.$bus.$emit("medical-practice-updated", practice);
          this.close();
        })
        .catch(() => {
          this.isPosting = false;
        });
    },

    close() {
      this.isPosting = false;
      this.isShowed = false;
      this.$emit("close");
    },
  },
};
</script>

<template lang="pug">
el-dialog(name="modal-medical-practice", :visible.sync="isShowed", :before-close="close", :title="isUpdate ? 'Editar práctica' : 'Nueva práctica'")
  .el-dialog__body
    ValidationObserver(v-slot="{handleSubmit}")
      form(@submit.prevent="handleSubmit(submit)")
        label.label * Descripción
        ValidationProvider(name="Descripción" rules="required" v-slot="{ errors }")
          el-input(v-model="practice.description")
          span.has-error {{ errors[0] }}

        label.label * Categoría
        ValidationProvider(name="Categoría" rules="required" v-slot="{ errors }")
          el-select(
            v-model="practice.category"
            allow-create
            filterable
            style="width: 100%"
          )
            el-option(
              v-for="category in categories"
              :key="category"
              :value="category"
              :label="category"
            )
          span.has-error {{ errors[0] }}

        label.label Estado
        el-checkbox(v-model="practice.isActive")
          | Práctica activa

        span(v-if="isUpdate")
          label.label ID
          el-input(v-model="practice._id" readonly)

  .el-dialog__footer
    el-button.button(type="info" @click="close()") Cancelar
    el-button.button(type="primary" :loading="isPosting" @click="submit") Guardar
</template>

<style lang="scss" scoped>
.el-dialog__body {
  padding: 0 20px 20px 20px;
}

.label {
  margin-top: 10px;
}

.modal {
  z-index: 9999;
}

.el-dialog__footer {
  display: flex;
  gap: 10px;
  justify-content: flex-end;

  .button {
    margin: 0;
  }
}
</style>
